/**
 * Acesso ao menu Financeiro / Gestão de reembolsos.
 *
 * 1) Primária: cliente com App Go (has_go_app / contrato id_produto 3 ou 4)
 * 2) Cargo: type Administrador (1), Gerente Técnico (2) ou Financeiro (4)
 * 3) Flags de ação: approve | pay | create (ao menos uma)
 * 4) asstec_financeiro_only: usuário vê somente o menu Financeiro
 */

import { parseUserType } from './userAnalisesAccess';

function isOn(v) {
  return v === 1 || v === true || v === '1';
}

/** Contrato Go (clientes_produtos id_produto 3 ou 4) na sessão. */
export function hasGoAppLicense(user) {
  if (isOn(user?.has_go_app)) return true;
  const p = Number(user?.go_id_produto);
  return p === 3 || p === 4;
}

/** App Go Premium (clientes_produtos id_produto 4). */
export function isGoPremiumLicense(user) {
  return Number(user?.go_id_produto) === 4;
}

/**
 * Cadastros → Compatibilidade de equipamentos.
 * App Go (produto 3 ou 4) + cargo Admin (1) / Gerente Técnico (2).
 */
export function canAccessCompatibilidadeEquipamentos(user) {
  if (!user) return false;
  const typeOk = ['1', '2'].includes(String(user.type));
  return typeOk && hasGoAppLicense(user);
}

/** Cargo permitido no menu Financeiro. */
export function isFinanceiroNavTypeAllowed(user) {
  const t = parseUserType(user);
  return t === 1 || t === 2 || t === 4;
}

export function isFinanceiroUserType(user) {
  return parseUserType(user) === 4;
}

/** Sessão restrita ao menu Financeiro (type 4 ou flag). */
export function isFinanceiroOnlyMode(user) {
  if (!user) return false;
  return isOn(user.asstec_financeiro_only) || isFinanceiroUserType(user);
}

export function hasReembolsoApprove(user) {
  return isOn(user?.asstec_reembolso_approve);
}

export function hasReembolsoPay(user) {
  return isOn(user?.asstec_reembolso_pay);
}

export function hasReembolsoCreate(user) {
  return isOn(user?.asstec_reembolso_create);
}

export function hasAnyReembolsoPermission(user) {
  return hasReembolsoApprove(user) || hasReembolsoPay(user) || hasReembolsoCreate(user);
}

/** Menu Financeiro + rota Gestão de reembolsos. */
export function canAccessFinanceiroMenu(user) {
  if (!user) return false;
  if (isFinanceiroOnlyMode(user)) return true;
  return (
    hasGoAppLicense(user) &&
    isFinanceiroNavTypeAllowed(user) &&
    hasAnyReembolsoPermission(user)
  );
}

export function canAccessGestaoReembolsos(user) {
  return canAccessFinanceiroMenu(user);
}

/** Exibir grupo de permissões de reembolso na edição de usuário. */
export function canShowReembolsoPermissionGroup(userOrTenantFlag) {
  if (userOrTenantFlag && typeof userOrTenantFlag === 'object') {
    return hasGoAppLicense(userOrTenantFlag);
  }
  return isOn(userOrTenantFlag);
}

export function getReembolsoUiPerms(user) {
  if (!hasGoAppLicense(user)) {
    return {
      canApproveReject: false,
      canPay: false,
      canCreateExpense: false,
    };
  }
  return {
    canApproveReject: hasReembolsoApprove(user),
    canPay: hasReembolsoPay(user),
    canCreateExpense: hasReembolsoCreate(user),
  };
}

